<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';

import {
  required,
  //email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Process",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      title: "Process registration",
      items: [
        {
          text: "Management",
          href: "/"
        },
        {
          text: "Industries",
          href: "/management/industries"
        },
        {
          text: "Industry",
          active: true
        }
      ],
      form: {
        id_industry:  "",
        nm_process:   "",
      },
      submitted:      false,
      isLoading:      false,
      user: {},
      industries:     [],
      processes:      [],
    };
  },
  validations: {
    form: {
      id_industry: {required},
      nm_process: {required, minLength: minLength(2), maxLength: maxLength(50)},
    }
  },
  watch:{},
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    this.getIndustries();
    if( this.$route.params.id ){
      this.getProcessByID( this.$route.params.id );
    }
  },
  methods: {

    getIndustries(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/industries.php',
        {
          params: {
            request: 'getIndustries',
          }
        }
      )
      .then(response => {
        console.log(response);
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.industries  = response.data
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getProcessByID(idProcess){
      let app = this;

      Swal.fire({
        title: "Loading process data.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });


      axios
      .get(
        window.serverPath+'dist/mvw/controllers/processes.php',
        {
          params: {
            request: 'getProcessByID',
            id: idProcess
          }
        }
      )
      .then(response => {
        console.log(response);
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.id_process  = response.data.id_process;
            app.form.id_industry = response.data.id_industry;
            app.form.nm_process  = response.data.nm_process;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          app.$swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    // eslint-disable-next-line no-unused-vars
    saveProcess(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();

      console.log(this.$v.form);
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_process  = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving process.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/processes.php', {
          request: 'saveProcess',
          data: this.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The process is correct "+action+"!", "success");
          app.$router.push({ name: 'processes' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                app.$router.push({ name: 'processes'});
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });

        /*
        Swal.fire("Good job!", "Your industry is saved now!", "success")
        .then(() => {
          self.submitted = false;
          self.form.id_industry       = "";
          self.form.nm_industry = "";
        });
        */
      }
    },

    resetSite(){
      this.form.id_industry = "";
      this.form.id_process  = "";
      this.form.nm_process  = "";
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveProcess">
              <div class="row">
                <div class="col-lg-4" >
                  <h4 class="card-title">Process</h4>
                  <p class="card-title-desc">Register a new process into the system.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="id_industry">Industry</label>
                        <select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_industry.$error }"
                          name="id_industry"
                          id="id_industry"
                          v-model="form.id_industry"
                        >
                          <option value="">SELECT YOUR INDUSTRY</option>
                          <option v-for="(industry, index) in industries" :key="index" :value="industry.id_industry">{{industry.nm_industry}}</option>
                        </select>
                        <div v-if="submitted && $v.form.id_industry.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_industry.required">Industry field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_process">Process name</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_process.$error }"
                          name="nm_process"
                          id="nm_process"
                          v-model="form.nm_process"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_process.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_process.required">Process name is required.</span>
                          <span v-if="!$v.form.nm_process.minLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                          <span v-if="!$v.form.nm_process.maxLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                </div>

                <div class="col-lg-4">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE PROCESS</button>
                    <router-link to="/management/processes" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>